import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

// Rich text (WYSIWYG) editor for program descriptions. Stores HTML.
const RichTextEditor = ({ value, onChange, placeholder }) => {
  const modules = useMemo(() => ({
    toolbar: [
      [{ header: [2, 3, 4, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'link'],
      [{ align: [] }],
      ['clean'],
    ],
  }), []);

  const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'blockquote', 'link', 'align'];

  return (
    <div className="rte bg-white/70 rounded-xl border border-rose/50 overflow-hidden">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder || 'Write a rich description…'}
      />
    </div>
  );
};

export default RichTextEditor;
